export function E(e: HTMLElement|Document) {
    return new EventTargetWrapper(e as EventTarget);
}

export class EventTargetWrapper {
    constructor(private e: EventTarget) {}

    once(type: string, listener: ((evt:Event) => boolean)|((evt:Event) => undefined), isCapture?: boolean) {
        let e = this.e;
        let l = function(evt:Event) {
            let v = listener(evt);
            if (v !== false) {
                e.removeEventListener(type, l, isCapture);
            }
        }
        e.addEventListener(type, l, isCapture);
    }
}

export function D(e: HTMLElement) {
    return new DomWrapper(e);
}

export class DomWrapper {
    constructor(private e: HTMLElement) {}

    inside(container: HTMLElement): boolean {
        return inside(container, this.e);
    }

    contains(element: HTMLElement): boolean {
        return inside(this.e, element);
    }

    closest(selector: string): HTMLElement | null {
        let e: HTMLElement | null = this.e;
        while (e != null) {
            let msElement = <any>e;
            if (msElement.msMatchesSelector ? msElement.msMatchesSelector(selector) : e.matches(selector)) {
                return e;
            }
            e = e.parentElement;
        }

        return e;
    }
}

// Helper functions

function isEventListenerObject(arg: any): arg is EventListenerObject {
    return arg.handleEvent !== undefined;
}

function inside(container: HTMLElement, target: HTMLElement|null): boolean {
    if (target === null) {
        return false;
    }
    if (target === container) {
        return true;
    }
    return inside(container, target.parentElement);
}